import FormSkeleton from '@/app/components/feedback/FormSkeleton';
import Skeleton from '@/app/components/feedback/Skeleton';

const AcceptanceInvitationSkeleton = () => (
  <div className="d-flex flex-column align-items-center justify-content-center bg-light min-vh-100">
    <div aria-busy="true" className="container py-10">
      <div className="mx-auto d-flex flex-column gap-8" style={{ maxWidth: 700 }}>
        <div className="card card-body gap-6">
          <Skeleton className="d-block" height={24} width="45%" />
          <FormSkeleton columnClassName="col-12 col-md-6" fieldCount={4} />
        </div>
        <div className="card card-body gap-6">
          <Skeleton className="d-block" height={24} width="35%" />
          <Skeleton className="d-block rounded" height={44} />
          <Skeleton className="d-block rounded" height={44} />
          <Skeleton className="d-block rounded" height={140} />
          <Skeleton className="d-block align-self-end rounded" height={44} width={200} />
        </div>
      </div>
    </div>
  </div>
);

export default AcceptanceInvitationSkeleton;
